// Prevent scrolling when submitting an invalid form
$('[data-focus-invalid="false"]').each((index, element) => {
  $(element).validate({ focusInvalid: false });
});
